module.exports = __webpack_public_path__ + "static/media/2.cc391181.png";